module.exports = __webpack_public_path__ + "static/media/3.c7510d3a.jpg";